import { render, staticRenderFns } from "./Queue.vue?vue&type=template&id=86ffce26&scoped=true"
import script from "./Queue.vue?vue&type=script&lang=js"
export * from "./Queue.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=86ffce26&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ffce26",
  null
  
)

export default component.exports